(() => {
    let isRefreshing = false;
    
    const triggerRefresh = (delay = 2500) => {
      if (isRefreshing) return;
      
      isRefreshing = true;
      
      setTimeout(() => {
        $.getJSON('/cart.js', function(cart) {
          buildCart(cart, true);
          
          setTimeout(() => {
            isRefreshing = false;
          }, 2500);
        });
      }, delay);
    };
    
    document.addEventListener("cartItemsUpdated", () => triggerRefresh());
    
    $(document).on("click", ".Sd_addProduct", () => triggerRefresh(4000));
  })();